import Template from 'backbone/story/templates/assets/image_field.js.hamlc'
import AssetDeleteConfirmationTemplate from 'backbone/story/templates/assets/asset_delete_confirmation.js.hamlc'
import ImageCommentView from 'backbone/story/views/comments/image_comment_view.js'
import Asset from 'backbone/platform/models/assets/asset.js'

export default class ImageFieldView extends Backbone.View
  events:
    "click .js-remove-asset" : "onDelete"

  initialize: (options) ->
    @options = options
    @asset = @_assetFromOptions(@options.asset)
    @listenTo(@asset, "change", @render)
    @commentCollection = page.get("storyComments")
    @render()

  render: =>
    @$el.html(
      Template(
        asset: @asset,
        AssetDeleteConfirmationTemplate: AssetDeleteConfirmationTemplate
      )
    )
    if @asset.get("persisted")
      @commentCollection.onFetched(@_initCommentView)

  onDelete: =>
    @asset.destroy
      success: =>
        @options.destroySuccess()
        @$el.closest(".delete-confirmation-wrapper").removeClass("delete-queue")
        if @imageCommentView
          @imageCommentView.remove(false)
          @imageCommentView = null

  _initCommentView: =>
    $imageEl = @$el.find(".js-image")

    if $imageEl[0].complete
      @_initImageCommentView()
    else
      $imageEl.on("load", @_initImageCommentView)

  _initImageCommentView: =>
    return if @imageCommentView

    @$el.addClass("js-comments-loaded")
    @imageCommentView = new ImageCommentView(
      el: @$el
      asset: @asset
    )

  _assetFromOptions: (assetData) ->
    if assetData.cid
      assetData
    else
      new Asset(assetData)



// WEBPACK FOOTER //
// ./app/javascript/backbone/story/views/assets/image_field_view.js.coffee